import { SkyscannerPartnermetadatasvcV1PartnerMetadata } from '@skyscanner-internal/partner-metadata-svc-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

const PARTNER_METADATA_CLIENT_NAME = 'PARTNER_METADATA';

export const partnerMetadataRequest = grpcFetchClientWrapper(
  SkyscannerPartnermetadatasvcV1PartnerMetadata.PartnerMetadataService.GetPartnerMetadata,
  {
    clientName: PARTNER_METADATA_CLIENT_NAME,
    pathPrefix: '/g/partner-metadata-svc',
  },
);
